export const BuildInfo = {timestamp:1779125788000}
